import { Injectable, OnInit } from "@angular/core";
import { UntypedFormGroup, Validators, UntypedFormArray, UntypedFormBuilder } from "@angular/forms";

import { activity, PillarRouteState, report } from "./models";

import { KEY } from "./constants/GSF-report.const";

@Injectable({ providedIn: "root" })
export class GSFReport implements OnInit {
  GSFReport: report;

  backToEmissionPage = false;
  gsfPage = true;

  gsfFormGroup: UntypedFormGroup;
  activityList: activity[] = [];

  activityId: string;
  pillarsLength: number;
  selectedPillarIndex = 0;
  private _wasteConfigJson: any = "";

  private _gsfValid = true;
  _previousSelectedTab = 0;
  dbCallFlag = true;

  private formatedPillars: PillarRouteState[] = [];
  constructor(private readonly fb: UntypedFormBuilder) {
    this.createGSFFormGroup();
  }
  ngOnInit() {}

  public setFormatedPillars(formatedPillars) {
    this.formatedPillars = formatedPillars;
  }

  public getFormatedPillars() {
    return this.formatedPillars;
  }

  createPillarFormGroup(pillar) {
    const pillarGroup: UntypedFormGroup = new UntypedFormGroup({
      activitiesFormGroup: new UntypedFormArray([]),
    });

    pillar.activities.forEach((pillarActivity) => {
      const activitiesList = pillarGroup.get(
        "activitiesFormGroup"
      ) as UntypedFormArray;
      activitiesList.push(this.createActivityFormGroup(pillarActivity));
    });

    return pillarGroup;
  }

  createQuestionFormGroup(question): UntypedFormGroup {
    const questionForm: UntypedFormGroup = this.fb.group({
      inputList: this.fb.array([]),
    });

    question.inputList.forEach((input) => {
      if (input.type) {
        (questionForm.get("inputList") as UntypedFormArray).push(
          this.getFormControl()
        );
      }
    });

    return questionForm;
  }

  getFormControl() {
    return this.fb.control("");
  }

  getInputListQuestionWise(activityList, activityId) {
    const inputListQuestionWise = [];
    activityList.forEach((jsonQuestionArr) => {
      const question: any = {};
      question.id = activityId;
      question.inputList = this.getQuestionInputList(jsonQuestionArr);

      inputListQuestionWise.push(question);
    });
    return inputListQuestionWise;
  }

  public get gsfValid(): boolean {
    return this._gsfValid;
  }
  public set gsfValid(v: boolean) {
    this._gsfValid = v;
  }

  public get wasteConfigJson(): any {
    return this._wasteConfigJson;
  }
  public set wasteConfigJson(v: any) {
    this._wasteConfigJson = v;
  }

  onlyNumeric(event) {
    return event.charCode === KEY.BACKSPACE || event.charCode === 0
      ? null
      : event.charCode >= KEY.ZERO && event.charCode <= KEY.NINE;
  }

  private createActivityFormGroup(pillarActivity): UntypedFormGroup {
    const activityForm: UntypedFormGroup = this.fb.group({
      toggleFlagCtl: this.fb.control(false, Validators.required),
      questionList: this.fb.array([]),
    });
    pillarActivity.questionList.forEach((question) => {
      const questionList = activityForm.get("questionList") as UntypedFormArray;
      questionList.push(this.createQuestionFormGroup(question));
    });
    return activityForm;
  }

  private createGSFFormGroup(): void {
    this.gsfFormGroup = new UntypedFormGroup({
      pillarFormGroup: new UntypedFormArray([]),
    });
  }

  private getQuestionInputList(jsonQuestionArr) {
    const inputList = [];
    jsonQuestionArr.forEach((inputObj) => {
      if (inputObj.type) {
        inputList.push(inputObj.ans);
      }
    });
    return inputList;
  }
}
